import React from 'react';
import Modal from 'antd/lib/modal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  CheckForLocationConflictConfirmChangeArgs,
  ConfirmChangeFunctionType,
  GetConfirmChangeFunctionArgs,
} from '@modules/timetable';

const { confirm } = Modal;

const getConfirmChangeFunction = ({
  title,
  contentStartText,
}: GetConfirmChangeFunctionArgs): ConfirmChangeFunctionType => {
  return ({
    resolve,
    conflictingItemTitle,
    subjectName,
    batchName,
    batchClassName,
  }: CheckForLocationConflictConfirmChangeArgs) => {
    confirm({
      title,
      content: `The ${contentStartText} ${conflictingItemTitle} (${subjectName}) Batch - ${batchName} Class - ${batchClassName} at the same time. Are you sure about this move?`,
      icon: <ExclamationCircleOutlined />,
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: {
        danger: true,
      },
    });
  };
};

export default getConfirmChangeFunction;
